import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { RecurringPaymentInstruction } from '../../../../../models/submissions/recurring-payment-instruction';
import { RecurringPaymentAmountTypeEnum } from '../../../../../models/enum/shared/recurring-payment-amount-type.enum';
import { VbPaymentChangeRecurringPaymentFormGroup } from '../../../../../models/shared/forms/vb-payment-change-recurring-payment-form-group';
import { VbPaymentChangeDateDisplayMode } from './vb-payment-change-frequency-date-string.pipe';
import { BaseButtonSizeEnum } from '../../base-button/base-button-size.enum';
import {
  payingInstructionOrNull,
  VbPaymentChangePaymentsStepUtils
} from '../utils/vb-payment-change-payments-step.utils';

@Component({
  selector: 'app-vb-payment-change-recurring-payment-frequency-card',
  templateUrl: './vb-payment-change-recurring-payment-frequency-card.component.html',
  styleUrls: ['./vb-payment-change-recurring-payment-frequency-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeRecurringPaymentFrequencyCardComponent implements OnChanges {
  @Input({ transform: payingInstructionOrNull })
  activeInstruction: RecurringPaymentInstruction | null = null;
  @Input() scheduledForm: VbPaymentChangeRecurringPaymentFormGroup | null = null;
  @Input() cardTitle: string = '';
  @Input() unit: string = '';
  @Input() readonly = false;
  @Input() isMonthly = false;
  @Input() scheduledLocked = false;

  @Output() editClicked = new EventEmitter<void>();
  @Output() removeClicked = new EventEmitter<void>();

  public isScheduledStop = false;
  public isAnnualCleared = false;
  public scheduledEditVisibility: 'visible' | 'hidden' = 'visible';

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.scheduledLocked) {
      this.scheduledEditVisibility = this.scheduledLocked ? 'hidden' : 'visible';
    }
    if (changes.scheduledForm || changes.isMonthly || changes.activeInstruction) {
      this.isScheduledStop =
        this.scheduledForm?.controls.paymentAmount.value === 0 &&
        this.scheduledForm?.controls.recurringPaymentAmountType.value !== RecurringPaymentAmountTypeEnum.Minimum;
      this.isAnnualCleared =
        !this.isMonthly &&
        this.isScheduledStop &&
        !VbPaymentChangePaymentsStepUtils.annualPaymentHasOccurredThisYear(this.activeInstruction);
    }
  }

  public getActiveAmountType(instruction: RecurringPaymentInstruction): RecurringPaymentAmountTypeEnum {
    return instruction.useMinimumAmount
      ? RecurringPaymentAmountTypeEnum.Minimum
      : RecurringPaymentAmountTypeEnum.Custom;
  }

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
  protected readonly VbPaymentChangeDateDisplayMode = VbPaymentChangeDateDisplayMode;
}
